
export const PM_DASHBOARD= "PM_DASHBOARD";
export const FETCH_SITES_GATES = "FETCH_SITES_GATES";



